module.exports = __webpack_public_path__ + "static/media/kitchen.563840f5.svg";